module.exports = __webpack_public_path__ + "img/price-tag.d5af3be5.svg";